import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/users",
    BULK: "/users/bulk",
};
export const usersService = {
    /**
     * Get paginated list of users with filters
     */
    getUsers: (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.search)
            params.append("search", filters.search);
        if (filters.filter)
            params.append("filter", filters.filter);
        if (filters.role)
            params.append("role", filters.role);
        if (filters.page)
            params.append("page", filters.page.toString());
        if (filters.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        const queryString = params.toString();
        const url = queryString ? `${ENDPOINTS.LIST}?${queryString}` : ENDPOINTS.LIST;
        return apiClient.get(url);
    },
    /**
     * Get a single user by ID
     */
    getUser: (userId) => apiClient.get(`${ENDPOINTS.LIST}/${userId}`),
    /**
     * Create a new user
     */
    createUser: (data) => apiClient.post(ENDPOINTS.LIST, data),
    /**
     * Create multiple users at once
     */
    createUsers: (users) => apiClient.post(ENDPOINTS.BULK, users),
    /**
     * Update a user
     */
    updateUser: (userId, data) => apiClient.put(`${ENDPOINTS.LIST}/${userId}`, data),
    /**
     * Update user access permissions
     */
    updateUserAccess: (userId, data) => apiClient.put(`${ENDPOINTS.LIST}/${userId}/access`, data),
    /**
     * Update user complete (user data and permissions in one call)
     */
    updateUserComplete: (userId, data) => apiClient.put(`${ENDPOINTS.LIST}/${userId}`, data),
    /**
     * Delete a user
     */
    deleteUser: (userId) => apiClient.delete(`${ENDPOINTS.LIST}/${userId}`),
};
